import { Checkbox, Form, Input, Modal } from 'antd'
import * as React from 'react'
import { FormInstance } from 'antd/lib/form'

import { ContoCorrenteModel } from '../../models/ConfigurazioneModels'

import { IConfigurazioneService } from '../../services/ConfigurazioneService'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'

import { TTFormItem } from '../shared/TTFormItem'
import { TTModalProps } from '../shared/TTModalProps'
import { TTSelect } from '../shared/TTSelect'
import { renderSelectKeyValue } from '../../services/shared/SelectOptionRenderUtils'
import { YapilyLookup } from '../../models/YapilyModels'
import { IYapilyService } from '../../services/YapilyService'
import { IssuesCloseOutlined } from '@ant-design/icons'

interface ModalYapilyLookupProps extends TTModalProps {
    data?: YapilyLookup

}

class ModalYapilyLookupState {
    PsuIdMandatory: boolean
    PsuCorporateIdMandatory: boolean
    PsuIpAddressMandatory: boolean
    IsCbi: boolean
    IsEmbeddedFlow: boolean
    HasAccount: boolean
}

export class ModalYapilyLookup extends React.Component<ModalYapilyLookupProps, ModalYapilyLookupState> {

    service: IYapilyService
    formRef = React.createRef<FormInstance>()
    bacaRef = React.createRef<Input>()
    abiRef = React.createRef<Input>()
    idIstRef = React.createRef<Input>()
    idIstBusRef = React.createRef<Input>()

    constructor(props) {
        super(props)
        this.service = container.get(SERVICE_IDENTIFIER.YAPILY_SERVICE)
        this.state = new ModalYapilyLookupState()
        if (this.props.data != null) {
            this.setState({
                PsuIdMandatory: this.props.data.PsuIdMandatory,
                PsuCorporateIdMandatory: this.props.data.PsuCorporateIdMandatory,
                PsuIpAddressMandatory: this.props.data.PsuIpAddressMandatory,
                IsCbi: this.props.data.IsCbi,
                IsEmbeddedFlow: this.props.data.IsEmbeddedFlow,
                HasAccount: this.props.data.HasAccount
            })
        }
    }

    componentDidMount() {
    }

    closeModal = () => {
        this.formRef.current.resetFields()
        this.props.closeModal()
    }

    onSave = async () => {
        try {
            let data = await this.formRef.current.validateFields()
            let banca = data["Banca"]
            let abi = data["Abi"]
            let idIst = data["IdIstituto"]
            let idIstBus = data["IdIstitutoBusiness"]
            let model = new YapilyLookup()
            if (this.props.data != null)
                model = { ...this.props.data }

            model.PsuIdMandatory = this.state.PsuIdMandatory
            model.PsuCorporateIdMandatory = this.state.PsuCorporateIdMandatory
            model.PsuIpAddressMandatory = this.state.PsuIpAddressMandatory
            model.IsEmbeddedFlow = this.state.IsEmbeddedFlow
            model.IsCbi = this.state.IsCbi
            model.Banca = banca
            model.Abi = abi
            model.IdIstituto = idIst
            model.IdIstitutoBusiness = idIstBus
            model.HasAccount = this.state.HasAccount
            let resp = await this.service.Save(model)
            if (resp.IsValid == true) {
                this.closeModal()
                this.props.do()
            }
        } catch (err) {
            console.log(err)
        }
    }

    render() {
        let banca = ""
        let abi = ""
        let idIst = ""
        let idIstBus = ""
        let isCbi = false
        let psuIdMandatory = false
        let psuCorporateIdMandatory = false
        let psuIpAddressMandatory = false
        let isEmbeddedFlow = false
        let hasAccount = false
        if (this.props.data != null) {
            banca = this.props.data.Banca
            abi = this.props.data.Abi
            idIst = this.props.data.IdIstituto
            idIstBus = this.props.data.IdIstitutoBusiness
            isCbi = this.props.data.IsCbi
            psuIdMandatory = this.props.data.PsuIdMandatory
            psuCorporateIdMandatory = this.props.data.PsuCorporateIdMandatory
            psuIpAddressMandatory = this.props.data.PsuIpAddressMandatory
            isEmbeddedFlow = this.props.data.IsEmbeddedFlow
            hasAccount = this.props.data.HasAccount
        }


        return (
            <Modal
                title="Conto Corrente"
                visible={this.props.visible}
                onOk={this.onSave}
                onCancel={this.closeModal}>

                <Form ref={this.formRef}>
                    <TTFormItem name="Banca" label="Banca" initialValue={banca} rules={[{ required: true }]}>
                        <Input ref={this.bacaRef} />
                    </TTFormItem>
                    <TTFormItem name="Abi" label="Abi" initialValue={abi} rules={[{ required: true }]}>
                        <Input ref={this.abiRef} />
                    </TTFormItem>
                    <TTFormItem name="IdIstituto" label="Id istituto private" initialValue={idIst} rules={[{ required: false }]}>
                        <Input ref={this.idIstRef} />
                    </TTFormItem>
                    <TTFormItem name="IdIstitutoBusiness" label="Id istituto business" initialValue={idIstBus} rules={[{ required: false }]}>
                        <Input ref={this.idIstBusRef} />
                    </TTFormItem>

                    <Checkbox checked={isCbi} disabled={true}>
                        CBI Globe Gateway
                    </Checkbox>
                    <br />
                    <Checkbox checked={psuIdMandatory} onChange={e => this.setState({ PsuIdMandatory: e.target.checked })}>
                        PSU-ID obbligatorio
                    </Checkbox>
                    <br />
                    <Checkbox checked={psuCorporateIdMandatory} onChange={e => this.setState({ PsuCorporateIdMandatory: e.target.checked })}>
                        PSU-CORPORATE-ID obbligatorio
                    </Checkbox>
                    <br />
                    <Checkbox checked={psuIpAddressMandatory} onChange={e => this.setState({ PsuIpAddressMandatory: e.target.checked })}>
                        PSU-IP-ADDRESS obbligatorio
                    </Checkbox>
                    <br />
                    <Checkbox checked={isEmbeddedFlow} disabled={true}>
                        Embedded Flow
                    </Checkbox>
                    <Checkbox checked={hasAccount} disabled={true}>
                        ACCOUNT
                    </Checkbox>
                </Form>
            </Modal>
        )
    }
}